const finalTrial = {
  typeInfo: "noQuestions",
  title: "Online dersler için mükemmel bir uyum! 🎉",
  subtitle:
    "Öğretmen eşliğindeki ders formatı çocuğunuz için uygun olabilir: gerekli teknik imkânlara sahipsiniz, düzenli dersleri değerlendirmeye açıksınız ve başlamak için uygun koşullarınız var. İlk ücretsiz dersle başlayarak deneyin!",
  button: "Ücretsiz deneyin 🚀",
  nextStep: 7,
};

export default {
  newDesign: true,
  parameters: {
    landing_id: "GRMeScr56",
    segment: 11,
  },
  title: "Çocuğunuz için doğru öğrenme formatını bulun | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  startPage: {
    title:
      "Bu 5 soruyu yanıtlayın ve çocuğunuz için ücretsiz bir ders alın",
    subtitle:
      "Çocuğunuz dijital yaratıcılık alanında yeni beceriler kazanacak: çizgi film, animasyon, illüstrasyon, modelleme, 3D ve tasarım.",
    image: {
      url: "/welcome/fwd_latam_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Devam etmek için tıklayın 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Dersler çocuğunuz için faydalı olursa, düzenli derslere devam etmeyi düşünür müsünüz?",
      answers: [
        { answer: "Evet, bu seçeneği zaten değerlendiriyoruz.", nextStep: 2 },
        { answer: "Evet, fiyat makul olursa.", nextStep: 2 },
        {
          answer: "Henüz emin değiliz, daha fazla bilgiye ihtiyacımız var.",
          nextStep: 2,
        },
        {
          answer:
            "Hayır, çocuğumuz dersleri sevse bile ücretli ders almayı planlamıyoruz.",
          nextStep: 2,
        },
      ],
    },
    2: {
      question:
        "Evde dersler için kullanabileceğiniz bir masaüstü ya da dizüstü bilgisayar var mı?",
      answers: [
        { answer: "Evet, masaüstü ya da dizüstü bilgisayarımız var.", nextStep: 3 },
        { answer: "Şu anda yalnızca telefonumuz veya tabletimiz var.", nextStep: 3 },
      ],
    },
    3: {
      question: "Evinizdeki internet bağlantısı ne kadar kararlı?",
      answers: [
        { answer: "Kararlı, genellikle sorun yaşamıyoruz.", nextStep: 4 },
        { answer: "Bazen kesiliyor.", nextStep: 4 },
        { answer: "Sık sık kesiliyor.", nextStep: 4 },
      ],
    },
    4: {
      question:
        "Çocuğunuzun gelişimi için aylık ne kadar bütçe ayırabilirsiniz?",
      financial: true,
      answers: [
        { answer: "30 USD'ye kadar.", nextStep: 5 },
        { answer: "30–60 USD.", nextStep: 5 },
        { answer: "60–100 USD.", nextStep: 5 },
        { answer: "100 USD'den fazla.", nextStep: 5 },
      ],
    },
    5: {
      question: "Çocuğunuzun daha önce online ders deneyimi oldu mu?",
      answers: [
        { answer: "Hayır, henüz olmadı.", nextStep: 6 },
        { answer: "Evet, bir kez veya kısa bir süreliğine oldu.", nextStep: 6 },
        { answer: "Evet, düzenli olarak online ders alıyor.", nextStep: 6 },
      ],
    },

    6: finalTrial,

    7: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en uygun kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    8: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle:
        "Tanışalım; ne öğreneceğimizi ve dersin nasıl işlediğini görelim.",
      button: "Neredeyse bitti 🔥",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "Deneme dersinizden önce hızlı bir hatırlatma ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    11: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    12: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
